import React from "react"
import { Text, Image, Flex, Container } from "@chakra-ui/react"
import ProductFormPrice from "@app/components/Product/Form/ProductFormPrice"
import { ProductFormSwatches } from "@app/components/Product/Form/ProductFormSwatches"

interface ReviewAddProductCardProps {
  product: any
  swatches: any
}

const ReviewAddProductCard: React.FC<ReviewAddProductCardProps> = ({ product, swatches }) => {
  return (
    <Flex width={"100%"} flexDirection={"column"} mt={8}>
      <Flex width={"100%"}>
        <Flex gap={4} width={"100%"} flexDirection={"row"}>
          <Image width={"22"} height={"auto"} src={product.image} alt={product.title} />
          <Flex flexDirection={"column"}>
            <Text fontWeight={500}>{product?.title}</Text>
            <Text fontSize={"sm"}>{product.color}</Text>
            <ProductFormSwatches product={product} swatches={swatches} isReview={true} />
          </Flex>
          <Container justifyContent={"flex-end"} width={"fit-content"}>
            <ProductFormPrice flexShrink={0} product={product} size="lg" direction="column" alignItems="flex-end" spacing={[-1.5, -0.5]} />
          </Container>
        </Flex>
      </Flex>
    </Flex>
  )
}

export default ReviewAddProductCard
